// extracted by mini-css-extract-plugin
export default {"content":"PractitionerDetails_content__w9Xmh"};